export function cacheOperationLabel(id: string): string | undefined {
	if (/^cache-restore-\d+$/.test(id)) return "Cache restoration";
	if (/^cache-publish-\d+$/.test(id)) return "Cache publication";
	return undefined;
}

export function cacheDuration(startedAt?: string, finishedAt?: string, now = Date.now()): string | undefined {
	if (!startedAt) return undefined;
	const start = Date.parse(startedAt);
	const end = finishedAt ? Date.parse(finishedAt) : now;
	if (!Number.isFinite(start) || !Number.isFinite(end)) return undefined;
	const seconds = Math.max(0, Math.round((end - start) / 1000));
	return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}
